import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';
import { Button } from './../../../../themes/button';
import { AddCircleOutlineIcon, CheckCircleIcon, ArrowBackIcon, ArrowForwardIcon, CloseIcon, EditIcon, FilterListIcon } from './../../../../themes/icons';
import ThemeCustom from './../../../../themes/custom';

const styles = theme => ({
  root: {
    boxShadow: 'none',
    minWidth: 'auto',
    whiteSpace: 'nowrap',
    textTransform: 'inherit'
  },
  iconMarginRight: {
    marginRight: theme.spacing.unit / 2
  },
  iconXSmall: {
    minHeight: theme.spacing.unit * 3,
    padding: `${ 3 }px ${4}px`
  },
  primary: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.dark
    }
  },
  secondary: {
    color: theme.palette.secondary.contrastText,
    background: theme.palette.secondary.main,
    '&:hover': {
      background: theme.palette.secondary.dark
    }
  },
  success: {
    color: ThemeCustom.palette.success.contrastText,
    background: ThemeCustom.palette.success.main,
    '&:hover': {
      background: ThemeCustom.palette.success.dark
    }
  },
  info: {
    color: ThemeCustom.palette.info.contrastText,
    background: ThemeCustom.palette.info.main,
    '&:hover': {
      background: ThemeCustom.palette.info.dark
    }
  },
  warning: {
    color: ThemeCustom.palette.warning.contrastText,
    background: ThemeCustom.palette.warning.main,
    '&:hover': {
      background: ThemeCustom.palette.warning.dark
    }
  },
  danger: {
    color: ThemeCustom.palette.danger.contrastText,
    background: ThemeCustom.palette.danger.main,
    '&:hover': {
      background: ThemeCustom.palette.danger.dark
    }
  }
});

const variantIcon = {
  add: AddCircleOutlineIcon,
  remove: CloseIcon,
  edit: EditIcon,
  save: CheckCircleIcon,
  back: ArrowBackIcon,
  forward: ArrowForwardIcon,
  filter: FilterListIcon
};

const Btn = ({ children, variant, color, size, icon, sizeIcon, classes, disabled, loading, loadingText, ...rest }) => {

  const _color      = color ? classes[color] : null;
  const _sizeIcon   = (sizeIcon && sizeIcon === "xsmall" ) ? sizeIcon : "small";
  const _sizeXSmall =  size === "xsmall" ? classes.iconXSmall : null;

  let Icon;

  if(icon){
    Icon = variantIcon[icon];
  }

  return (
    <Button
        className={ classNames(_color, classes.root, _sizeXSmall ) }
        variant={ variant ? variant : "contained" }
        size={ _sizeIcon }
        disabled={ disabled || loading }
        { ...rest } disableRipple>

      { Icon && (
        <Icon className={ classNames( children ? classes.iconMarginRight : null) } fontSize={ _sizeIcon }/>
      )}

      { !loading ? (

        children

      ) : (
        <span>{ loadingText ? loadingText : "Procesando..." }</span>
      )}
    </Button>
  )

}

Btn.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'info', 'warning', 'danger']),
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  variant: PropTypes.oneOf(['contained', 'outlined', 'fab'])
};

export default withStyles(styles)(Btn);
